import { Overlay } from 'rcd-cpp-ui/ui/loader/Overlay';
import * as React from 'react';
import { isLoading } from './loaderAction';
import { SpinnerSize } from 'rcd-cpp-ui/ui/loader/spinner';

interface Props {
  fixed?: boolean;
  id?: string;
  spinnerSize?: SpinnerSize;
}

export const Loader = ({ id, ...props }: Props) => {
  const loading = isLoading(id);
  if (!loading) return null;
  return <Overlay {...props} />;
};

type Actions = {
  [x: string]: any;
};

type SpinnerProps = {
  spinnerSize?: SpinnerSize;
};

export const useLoader = <A extends Actions>(
  { message, setMessage, Alert, ...actions }: A,
  initState: boolean = false,
  props: SpinnerProps = {}
) => {
  const [isLoading, setLoading] = React.useState(initState);
  const Loader = (p: SpinnerProps) => {
    if (!isLoading) return null;
    return <Overlay {...props} {...p} />;
  };
  const _actions = {} as any;
  if (actions) {
    Object.keys(actions).forEach(name => {
      const fn = actions[name];
      if (typeof fn != 'function') {
        _actions[name] = fn;
        return;
      }
      _actions[name] = async (...args) => {
        setLoading(true);
        try {
          const r = fn(...args);
          if (r.then) return await r;
        } finally {
          setLoading(false);
        }
      };
    });
  }
  return {
    ...(_actions as A),
    message,
    setMessage,
    Alert,
    isLoading,
    setLoading,
    Loader
  };
};
